/*
| Shared export modal. A single "Export" button (data-export-open) carries its
| available formats in data-export-formats (JSON: [{label, url}]); clicking it
| opens a format chooser and navigates to the chosen download. Mirrors the
| admin ExportModal UX in vanilla TS (the theme has no Vue runtime on FE pages).
*/
interface ExportFormat { label: string; url: string; }

let backdrop: HTMLElement | null = null;
let modal: HTMLElement | null = null;
let invoker: HTMLElement | null = null;

const build = (): void => {
    if (modal) return;
    backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop';
    backdrop.hidden = true;
    backdrop.addEventListener('click', close);

    modal = document.createElement('div');
    modal.className = 'modal export-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Export');
    modal.hidden = true;
    modal.innerHTML =
        '<h2>Export</h2>'
        + '<div class="export-formats" data-export-list></div>'
        + '<div class="f-actions"><button type="button" class="btn-cta" data-export-download>Stáhnout</button>'
        + '<button type="button" class="f-cancel" data-export-close>Zavřít</button></div>';
    modal.querySelector('[data-export-download]')!.addEventListener('click', download);
    modal.querySelector('[data-export-close]')!.addEventListener('click', close);
    document.body.append(backdrop, modal);
};

function onKey(e: KeyboardEvent): void { if (e.key === 'Escape') close(); }

function open(button: HTMLElement): void {
    build();
    let formats: ExportFormat[] = [];
    try { formats = JSON.parse(button.dataset.exportFormats ?? '[]'); } catch { formats = []; }
    if (!formats.length) return;
    invoker = button;
    const list = modal!.querySelector<HTMLElement>('[data-export-list]')!;
    list.innerHTML = '';
    formats.forEach((f, i) => {
        const label = document.createElement('label');
        label.className = 'export-fmt';
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'export-fmt';
        radio.value = f.url;
        if (i === 0) radio.checked = true;
        const span = document.createElement('span');
        span.textContent = f.label;
        label.append(radio, span);
        list.appendChild(label);
    });
    backdrop!.hidden = false;
    modal!.hidden = false;
    document.addEventListener('keydown', onKey);
    modal!.querySelector<HTMLElement>('input')?.focus({ preventScroll: true });
}

function download(): void {
    const chosen = modal?.querySelector<HTMLInputElement>('input[name="export-fmt"]:checked');
    if (chosen) window.location.href = chosen.value;
}

function close(): void {
    if (!modal || modal.hidden) return;
    backdrop!.hidden = true;
    modal.hidden = true;
    document.removeEventListener('keydown', onKey);
    invoker?.focus({ preventScroll: true });
}

export function initExportModal(): void {
    document.querySelectorAll<HTMLElement>('[data-export-open]').forEach((btn) => {
        btn.addEventListener('click', () => open(btn));
    });
}
